import { z } from 'zod'

/** 國家 Schema */
export const countrySchema = z.object({
  areaCode: z.string(),
  code: z.string(),
  name: z.string(),
  enable: z.boolean()
})

/** 國家 */
export interface Country extends z.infer<typeof countrySchema> {}
